import React from 'react'
import { NavLink, useParams } from 'react-router-dom'

import { useQueryParams } from '../hooks/queryString'
import { useLoad } from '../hooks/request'
import { CLIENT_DETAIL, ORDER_ARCHIVE_LIST } from '../urls'
import Layout from '../components/Layout'
import DateFilter from '../components/common/DateFilter'
import ClientOrderTableItem from '../components/ClientOrderTableItem'
import SearchFilter from '../components/common/SearchFIlter'
import { format } from '../utils/number'
import NewTable from '../components/common/NewTable'

export default function ClientOrders() {
    const { clientId } = useParams()
    const params = useQueryParams()

    const classDetail = useLoad({ url: CLIENT_DETAIL.replace('{id}', clientId) })
    const client = useLoad({
        url: ORDER_ARCHIVE_LIST,
        params: { client: clientId, ...params },
    }, [params])
    const orderList = client.response?.results || []
    const className = classDetail.response

    const totalForOrderHistoriesSum = client.response ? client.response.totalForOrderHistoriesSum : 0
    const pribil = client.response ? client.response.pribil : 0
    return (
        <Layout>
            <header className="is-flex mb-3">
                <div>
                    <NavLink className="is-white is-link is-outlined mr-2" to="/client">
                        <i className="icon ion-md-arrow-back is-size-4 mt-2 mr-2" />
                    </NavLink>
                </div>

                <SearchFilter />

                <DateFilter className="ml-2" name="date" />

                <div className="date_filter ml-2" style={{ display: 'flex', }}>
                    <DateFilter className="mr-2" name="startDate" />
                    <DateFilter name="endDate" />
                </div>

                <span className="is-info is-light is-medium mt-2 ml-3 is-pulled-right">
                    {className ? className.name : ''} - {className ? className.phoneNumber : ''}
                </span>
            </header>

            <div style={{ gap: 10 }} className="mb-2 is-flex">
                <b>
                    <p className="is-bold is-light is-size-5">Общая сумма
                        продаж: <span className="ml-2">{format(totalForOrderHistoriesSum)} сум</span>
                    </p>
                </b>
                <b>
                    <p className="is-bold is-light is-size-5">Общая сумма
                        прибыль: <span className="ml-2">{format(pribil)} сум</span>
                    </p>
                </b>
            </div>
            <NewTable
                totalCount={client.response ? client.response.count : 0}
                pageSize={15}
                loading={client.loading}
                columns={{ 0: '№', 1: 'Общая сумма', 2: 'Дата', actions: '' }}
                items={orderList}
                renderItem={(item, index) => <ClientOrderTableItem index={index} key={item?.id} item={item} />} />
        </Layout>
    )
}
